// window.history.scrollRestoration = 'manual';

HTMLDocument.prototype.ready = function () {
  return new Promise((resolve, reject) => {
    if (document.readyState === "complete") {
      resolve(document);
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        resolve(document);
      });
    }
  });
};

HTMLDocument.prototype.safeWidth = function () {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  );
};

HTMLVideoElement.prototype.playSafe = function () {
  try {
    this.play()
      .then(() => {})
      .catch(() => {});
  } catch (err) {}
};

HTMLVideoElement.prototype.reset = function () {
  this.pause();
  try {
    this.currentTime = 0;
  } catch (err) {}
};
